import { useEffect } from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import { findGuide } from './constants/guides';
import { SITE_NAME } from './constants/site';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import CookiePolicy from './pages/CookiePolicy';
import DisclaimerPage from './pages/DisclaimerPage';
import FaqsPage from './pages/FaqsPage';
import Ftm2019Page from './pages/Ftm2019Page';
import Ftm2024Page from './pages/Ftm2024Page';
import GuideArticlePage from './pages/GuideArticlePage';
import GuidesPage from './pages/GuidesPage';
import HomePage from './pages/HomePage';
import NotFound from './pages/NotFound';
import PrivacyPolicy from './pages/PrivacyPolicy';
import RefundPolicy from './pages/RefundPolicy';
import SupportServicesPage from './pages/SupportServicesPage';
import TermsPage from './pages/TermsPage';

const PAGE_TITLES = {
  '/': `${SITE_NAME} | Independent Family Tree Maker Support`,
  '/about-us': `About Us | ${SITE_NAME}`,
  '/contact-us': `Contact Us | ${SITE_NAME}`,
  '/support-services': `Support Services | ${SITE_NAME}`,
  '/family-tree-maker-2024': `Family Tree Maker 2024 Support | ${SITE_NAME}`,
  '/family-tree-maker-2019': `Family Tree Maker 2019 Support | ${SITE_NAME}`,
  '/guides': `Free Guides | ${SITE_NAME}`,
  '/faqs': `FAQs | ${SITE_NAME}`,
  '/privacy-policy': `Privacy Policy | ${SITE_NAME}`,
  '/terms-and-conditions': `Terms & Conditions | ${SITE_NAME}`,
  '/refund-policy': `Refund Policy | ${SITE_NAME}`,
  '/cookie-policy': `Cookie Policy | ${SITE_NAME}`,
  '/disclaimer': `Disclaimer | ${SITE_NAME}`,
};

function DocumentTitle() {
  const { pathname } = useLocation();

  useEffect(() => {
    const guide = pathname.startsWith('/guides/') && findGuide(pathname.slice(8));
    document.title = guide ? `${guide.title} | ${SITE_NAME}` : PAGE_TITLES[pathname] || `Page Not Found | ${SITE_NAME}`;
  }, [pathname]);

  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <DocumentTitle />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about-us" element={<AboutPage />} />
        <Route path="/contact-us" element={<ContactPage />} />
        <Route path="/support-services" element={<SupportServicesPage />} />
        <Route path="/family-tree-maker-2024" element={<Ftm2024Page />} />
        <Route path="/family-tree-maker-2019" element={<Ftm2019Page />} />
        <Route path="/guides" element={<GuidesPage />} />
        <Route path="/guides/:slug" element={<GuideArticlePage />} />
        <Route path="/faqs" element={<FaqsPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsPage />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="/disclaimer" element={<DisclaimerPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
